module.exports = __webpack_public_path__ + "img/Wp_2080.e38704cb.png";